export const environment = {
  production: false,
  id: '5c',
  baseUrl: 'https://5c.superlikerslabs.com',
  photosPath: 'https://superlikers-staging.s3.amazonaws.com/uploads/upload-photo',
  /** Lambda que registra al nuevo líder de un centro y bloquea al anterior. */
  registerUrl: 'https://wbktv3puaxngaslyqhkezkvk3a0yzhzg.lambda-url.us-east-1.on.aws/',
  /** Lambda que recibe la imagen del ticket y la carga al centro de consumo del gerente. */
  invoicesUrl: 'https://hslvn74uevmi74vktdleqxmlta0kvbwt.lambda-url.us-east-1.on.aws/v1/ticket-submissions',
  /** Token de homologación del endpoint de tickets. Viaja en el bundle: no es un secreto. */
  invoicesToken: '0c118a2ae9731afeda32c39395017506c6bb16fd644c9cfcefc03aa72a8df0d1',
  /** En `false`, /login muestra un aviso en vez del formulario; el resto de auth sigue igual. */
  loginEnabled: true
}
